export function setJSExceptionHandler(errorHandler) {
  window.onerror = function(msg, src, ln, col, err) {
    errorHandler(err);
  };
}
